import { Link as RouteLink, Outlet } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Button, Link } from '@chakra-ui/react'
import { graphql } from '@/__generated__/gql'
import { usePagination } from '@/hooks/use-pagination'
import { formatPhoneNumber } from '@/utils/format'
import { FullLayout } from '@/components/full-layout'
import { ContainerBox } from '@/components/container-box'
import { Table, Tbody, Td, Th, Thead, Tr } from '@/components/table'
import { Row, Rows } from '@/components/rows'
import { Heading } from '@/components/heading'
import { useViewer } from '@/components/viewer-context-provider'
import { LoadingSection } from '@/components/loading-section'

export const specialistsDocument = graphql(`
  query Specialists($input: ConnectionInputArgs!) {
    specialists(input: $input) {
      totalCount
      results {
        id
        name
        mobile
        email
        categories {
          id
          name
        }
      }
    }
  }
`)

export function SpecialistsRoute() {
  const { Pagination, variables } = usePagination()
  const { isAdmin } = useViewer()
  const { data, loading, error } = useQuery(specialistsDocument, {
    variables: { input: variables },
  })
  const specialists = data?.specialists.results || []
  const totalCount = data?.specialists.totalCount || 0

  if (error) throw error

  return (
    <FullLayout>
      <ContainerBox>
        <Rows>
          <Row>
            <Heading
              title="Spesialister"
              actions={
                isAdmin ? (
                  <Button as={RouteLink} to="new" size="sm" colorScheme="blue">
                    Ny spesialist +
                  </Button>
                ) : null
              }
            />
          </Row>
          <Row>
            <Table>
              <Thead>
                <Tr>
                  <Th>Navn</Th>
                  <Th>Mobil</Th>
                  <Th>E-post</Th>
                  <Th>Kategorier</Th>
                </Tr>
              </Thead>
              <Tbody>
                {specialists.map((specialist) => (
                  <Tr key={specialist.id}>
                    <Td>
                      <Link as={RouteLink} to={specialist.id}>
                        {specialist.name}
                      </Link>
                    </Td>
                    <Td>{formatPhoneNumber(specialist.mobile)}</Td>
                    <Td>{specialist.email}</Td>
                    <Td>
                      {specialist.categories.map(({ name }) => name).join(', ')}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            {loading && <LoadingSection />}
          </Row>
          {totalCount > variables.limit && (
            <Row>
              <Pagination total={totalCount} />
            </Row>
          )}
        </Rows>
      </ContainerBox>

      <Outlet />
    </FullLayout>
  )
}
